/**
 * IM入口
 * author: jiaheming
 * date: 2019/06/12
 */
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import actions from '../../actions';
import { closeChat, toggleIM } from '../../actions/actionCreators';
import { initializeIM, showImageDialog } from '../../actions/actions';
import config from '../../config';
import Loading from '../common/Loading';
import IMChat from './IMChat';
import IMList from './IMList';

const IMWindowStyle = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 24px 0 rgba(171, 171, 171, 0.5);
    display: flex;
    flex-direction: column;
    transition: all 0.5s;
    color: initial;
    cursor: auto;

    &.show {
        width: 400px;
        transition: all 0.5s;
        // ------------
    }

    &.hidden {
        right: -400px;
        transition: all 0.5s;
    }
`;
const IMMainStyle = styled.div`
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: row;
    width: 100%;
    overflow: hidden;
`;
const ModalStyle = styled(Modal)`
    width: 80%;
    height: 80%;

    .ant-modal-content {
        width: 100%;
        height: 100%;

        & > button {
            top: 8px;
            right: -12px;
        }

        .ant-modal-body {
            height: 100%;
            width: 100%;
            position: relative;

            & > img {
                margin: 0 auto;
                max-width: 80%;
                max-height: 80%;
                display: block;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
`;

class IM extends React.Component {
    componentDidMount() {
        const { notificationCallback, switchSessionCallback, externalInit } = this.props;

        if (!externalInit) {
            this.props.initializeIM(this.props.userInfo);
            this.props.setNotificationCallback(notificationCallback);
            this.props.setSwitchSessionCallback(switchSessionCallback);
        }
    }

    render() {
        const {
            // closeChat,
            // resetSession,
            fnShowImageDialog,
            showImageDialog,
            imgUrl,
        } = this.props;

        return (
            <IMWindowStyle>
                <IMMainStyle>
                    <IMList
                        closeCallback={this.props.closeCallback}
                        improveInfoCallback={this.props.improveInfoCallback}
                    />
                    <IMChat customComponent={this.props.customComponent} />
                </IMMainStyle>
                <Loading isLoading={this.props.isLoading} />
                <ModalStyle
                    title=""
                    visible={showImageDialog}
                    destroyOnClose
                    footer={null}
                    width={'80%'}
                    onCancel={() => {
                        fnShowImageDialog(false);
                    }}
                >
                    <img style={{ margin: '0 auto', width: 'auto', display: 'block' }} src={imgUrl} alt="" />
                </ModalStyle>
            </IMWindowStyle>
        );
    }
}

IM.propTypes = {
    userInfo: PropTypes.shape({
        userId: PropTypes.string.isRequired,
        userName: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
    }),
    imgUrl: PropTypes.string.isRequired,
    customComponent: PropTypes.node,
    switchSessionCallback: PropTypes.func,
    notificationCallback: PropTypes.func,
    improveInfoCallback: PropTypes.func,
    closeCallback: PropTypes.func,
    fnShowImageDialog: PropTypes.func,

    showIM: PropTypes.bool.isRequired,
    showChat: PropTypes.bool.isRequired,
    showImageDialog: PropTypes.bool.isRequired,
    toggleIM: PropTypes.func.isRequired,
    closeChat: PropTypes.func.isRequired,
    resetSession: PropTypes.func.isRequired,
    connect: PropTypes.func.isRequired,
    initializeIM: PropTypes.func.isRequired,
    setNotificationCallback: PropTypes.func,
    setSwitchSessionCallback: PropTypes.func,
};

function mapStateToProps(store) {
    const {
        showIM,
        showChat,
        imStore: { isLoading },
        showImageDialog,
        imgUrl,
    } = store[config.reduxStoreName];

    return { showIM, showChat, isLoading, showImageDialog, imgUrl };
}

const IMPage = connect(mapStateToProps, {
    initializeIM,
    connect: actions.connect,
    toggleIM,
    closeChat: closeChat,
    resetSession: actions.resetCurrSession,
    setNotificationCallback: actions.setNotificationCallback,
    setSwitchSessionCallback: actions.setSwitchSessionCallback,
    fnShowImageDialog: showImageDialog,
})(IM);

export default IMPage;
